import useAZZKUYears from "hooks/AZZKU/useAZZKUYears";
import Select from "components/Select";
import Loader from "components/Loader";

export default function Step2({ params, errors, onChange }) {

   const { d: years } = useAZZKUYears({
      variable_id: params.variable_id
   });

   return years ? (
      <>
         <p> Wybierz rok, dla którego chcesz wyświetlić dane. </p>

         <Select
            name="year"
            value={ params.year }
            error={ errors.year }
            label="Wybierz rok"
            options={ years }
            label_style={{ flex: "0 0 300px" }}
            style={{ maxWidth: "800px" }}
            onChange={ onChange }
         />
      </>
   ) : <Loader/>
}